module.exports = __webpack_public_path__ + "static/OGImage-416593635aadc5f9f6b111079989c486.jpg";